// axios
import axios from "axios";

const domain = "https://comaylink.com";

export default axios.create({
	domain
	// You can add your headers here
});
